export const environment = {
  production: false,
  localhost: false,
  domain: "https://udadesigner-api-test.azurewebsites.net",
  name: "TEST"
};
